<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <b-card>
      <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
      <div v-else class="address">
        <b-form inline class="formBox">
          <b-form-group class="inputGrp" label="" label-for="protocols">
            <b-form-select
              v-model="selectedProtocol"
              :options="protocols"
              :select-size="20"
              text-field="name"
              value-field="id"
            ></b-form-select>
            <div class="buttons">
              <b-button
                variant="primary"
                :title="$t('general.add')"
                @click="openModal(true, 'add')"
              >
                <b-icon icon="file-earmark-plus-fill"></b-icon>
              </b-button>
              <b-button
                variant="success"
                :title="$t('general.edit')"
                @click="openModal(true, 'edit', protocol)"
                :disabled="protocol.id?false:true"
              >
                <b-icon icon="pen-fill"></b-icon>
              </b-button>
              <b-button
                variant="danger"
                :title="$t('general.delete')"
                @click="openModal(true, 'delete', protocol)"
                :disabled="protocol.id?false:true"
              >
                <b-icon icon="trash"></b-icon>
              </b-button>
            </div>
          </b-form-group>
          <div style="flex: 2; height: 600px;" class="inputGrp" v-if="eventCodes && eventCodes.length > 0">
            <b-table-simple hover responsive>
              <b-thead>
                <b-th> {{$t('defination.eventCodes.list.event_code')}} </b-th>
                <b-th> {{$t('defination.eventCodes.list.signal_type')}} </b-th>
                <b-th> {{$t('defination.eventCodes.list.alarm')}} </b-th>
                <b-th>
                  <b-button
                      size="sm"
                      :title="$t('general.add')"
                      variant="primary"
                      @click="openModal(true, 'addEventCode', {signalTypes,selectedProtocol})"
                  >
                      <b-icon icon="plus" aria-hidden="true"></b-icon>
                      {{$t('general.add')}}
                  </b-button>
                </b-th>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in eventCodes" :key="item.id">
                  <b-td>{{item.event_code}}</b-td>
                  <b-td>{{item.signal_types.description}}</b-td>
                  <b-td>
                    <b-icon :icon="item.is_alarm?'check':'x'" :variant="item.is_alarm?'success':'danger'"></b-icon>
                    <b-badge :variant="item.is_alarm?'success':'danger'"> {{$t('defination.eventCodes.list.alarm')}} </b-badge></b-td>
                  <b-td>
                  <b-button
                    size="sm"
                    variant="success"
                    :title="$t('general.edit')"
                    @click="openModal(true, 'editEventCode', {item,signalTypes,selectedProtocol})"
                  >
                    <b-icon icon="pen-fill"></b-icon>
                  </b-button>

                    <b-button
                      size="sm"
                      title="Sil"
                      variant="danger"
                      @click="openModal(true, 'delete', {modalType:'eventCode',item,selectedProtocol})"
                    >
                      <b-icon icon="trash" aria-hidden="true"></b-icon>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        
        </b-form>
          <template v-if="ECPageInfo">
                <b-pagination
                    style="justify-content: right;"
                    v-model="page"
                    :total-rows="ECPageInfo.count"
                    :per-page="ECPageInfo.limit"
                ></b-pagination>
            </template>
      </div>
    </b-card>
    <Modals
      :open="modalOpen"
      :modalEvent="openModal"
      :modalProps="modalProps"
      :form="currentForm"
      :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import i18n from "@/plugins/i18n";
import Modals from "./modals/";

let breadCrumb = [
  { label: i18n.t("pages.defination.name"), url: "/Defination" },
  {
    label: i18n.t("pages.defination.signalProtocols"),
    url: "/Defination/Protocols"
  }
];
export default {
  name: "SignalProtocols",
  async created() {
    await this.$store.dispatch("signalprotocol_list");
    await this.$store.dispatch("listSignalTypes")
  },
  computed: {
    protocols() {
      return this.$store.getters.getProtocols;
    },
    ECPageInfo() {
      return this.$store.getters.getEventCodesPageInfo;
    },
    eventCodes() {
      return this.$store.getters.getEventCodes
    },
    loading() {
      return this.$store.getters.getDefinationLoading;
    },
    signalTypes() {
        return this.$store.getters.getSignalTypes.map(type=>{
            return (
                {...type,text:type.code+" -> "+type.description}
            )
        })
    }
  },
  watch: {
    async selectedProtocol(val) {
      this.protocol = this.protocols.find(
        protocol => protocol.id === this.selectedProtocol
      );
      await this.$store.dispatch("listEventCodes",{protocol:this.selectedProtocol, ...this.params});
    },
    limit(val){
        this.params['limit'] = val
        this.$store.dispatch('listEventCodes', {protocol:this.selectedProtocol, ...this.params})
    },
    offset(val){
          this.params['offset'] = val
          this.$store.dispatch('listEventCodes', {protocol:this.selectedProtocol, ...this.params})
    },
    page(val){
      if(val > 0){
          this.page = val
          this.offset = ((val-1) * this.limit)
      }
    }
  },
  data: function() {
    return {
      breadCrumb,
      modalOpen: false,
      modalProps: {},
      currentForm: "SignalProtocol",
      modalName: "",
      protocol: {},
      selectedProtocol: 0,
      limit:20, page: 1, offset: 0,
      params:{
        limit: 20,
        offset: 0,
      }
    };
  },
  components: {
    BreadCrumb,
    Modals
  },
  methods: {
    openModal: function(state, modal, props) {
      this.modalOpen = state;
      this.modalProps = props;
      this.modalName = modal;
    }
  }
};
</script>

<style lang="css" scoped>
@import "./styles/signalProtocol.min.css";
</style>



// WEBPACK FOOTER //
// src/pages/General/Defination/SignalProtocols.vue